import React, { useEffect } from "react";
import { SelectDevices } from "./SelectDevices";

const TITLE = "User verify entities";

export const USER_VERIFY_ID = "userVerify";

const userVerifyDevicesData = [
  {
    id: USER_VERIFY_ID,
    label: "User verify",
  },
];

const SelectUserVerifyDevices = ({ selectedDevices, onChange, loadingDevices, disabled }) => {
  useEffect(() => {
    loadingDevices.add(1);
    onChange(userVerifyDevicesData);
    loadingDevices.done();
  }, []);
  
  return (
    <SelectDevices
      title={TITLE}
      data={userVerifyDevicesData}
      onChange={onChange}
      selectedDevices={selectedDevices}
      disabled={disabled}
    />
  );
};

export default SelectUserVerifyDevices;
